export default __webpack_public_path__ + "static/media/GothamMedium.b23bb62d.ttf";